import Logo2020Trade from '../../src/legacy/Logo2020Trade.tsx';
export default Logo2020Trade;
